import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import RecordsColumnsSearch from "./recordsColumnsSearch";
import EntriesPagination from "./entriesPagination";

const CustomDataTable = props => {
  const ASC = "asc";
  const DESC = "desc";

  const [selectedSortColumn, setSelectedSortColumn] = useState(null);
  const [currFilters, setCurrFilters] = useState(
    props.tabFilters
      ? props.tabFilters
      : {
          skip: 0,
          limit: 10
        }
  );

  useEffect(() => {
    setSelectedSortColumn(null);
  }, [props.tabFilters]);

  // restore the previous page
  useEffect(() => {
    if (props.tabFilters) {
      paginationUpdated(props.tabFilters.skip);
    }
  }, []);

  const setRecordsFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.text = filters.text;

    if (
      props.totalRecords === parseInt(filters.limit) ||
      props.totalRecords <= parseInt(filters.limit)
    ) {
      newFilter.skip = 0;
    }

    setCurrFilters(newFilter);
    if (didFiltersChange(newFilter))
      props.setFilters(newFilter);
  };

  const didFiltersChange = (newFilter) => {
    for (const key in newFilter) {
      if (newFilter[key] !== currFilters[key]) return true;
    }
    return false;
  };

  const paginationUpdated = skip => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.skip = skip;
    setCurrFilters(newFilter);
    if (didFiltersChange(newFilter))
      props.setFilters(newFilter);
  };

  const sortTableByColumn = column => {
    let srt = null;

    if (selectedSortColumn === null || column !== selectedSortColumn.column) {
      srt = {
        order: ASC,
        column: column
      };
    } else if (
      selectedSortColumn !== null &&
      column === selectedSortColumn.column
    ) {
      if (selectedSortColumn.order === ASC) {
        srt = {
          order: DESC,
          column: column
        };
      } else {
        srt = {
          order: ASC,
          column: column
        };
      }
    }

    setSelectedSortColumn(srt);
    if (props.sortData) {
      props.sortData(srt);
    }
  };

  return (
    <div className="data-table-container mt-4">
      {!props.disableFilterPagination && !props.disableTopFilters && (
        <RecordsColumnsSearch
          recordLimit={props.tabFilters ? props.tabFilters.limit : 10}
          totalRecords={props.totalRecords}
          setFilters={setRecordsFilters}
          disbleAll={props.disbleAll}
          disableSearchText={props.disableSearchText}
          searchColumnText={props.searchColumnText}
        />
      )}
      <div className="table-container mt-4">
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              {props.headers.map((header, i) => (
                <th
                  onClick={e => {
                    if (props.sortableTable === true) {
                      if (
                        header.sort === undefined ||
                        (header.sort && header.sort !== false)
                      ) {
                        sortTableByColumn(header.key);
                      }
                    }
                  }}
                  style={header.customStyle ? header.customStyle : {}}
                  key={i}
                  className={
                    selectedSortColumn === null ||
                    header.key !== selectedSortColumn.column
                      ? props.sortableTable === true
                        ? "table-sort"
                        : ""
                      : header.key === selectedSortColumn.column &&
                        selectedSortColumn.order === ASC
                      ? "table-sort-asc"
                      : "table-sort-desc"
                  }
                >
                  {header.value}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.totalRecords > 0 && props.children}
            {props.totalRecords === 0 && (
              <tr style={{ backgroundColor: "#fff" }}>
                {props.headers.map((h, i) => {
                  if (i === 0) {
                    return (
                      <td style={{ border: "none" }} key={i}>
                        No data is available
                      </td>
                    );
                  } else {
                    return <td style={{ border: "none" }} key={i}></td>;
                  }
                })}
              </tr>
            )}
          </tbody>
        </table>
        <div
          className={props.bottomContent !== "" ? "mb-3" : "mb-0"}
          dangerouslySetInnerHTML={{ __html: props.bottomContent }}
        ></div>
      </div>
      {!props.disableFilterPagination && (
        <EntriesPagination
          itemsPerPage={currFilters.limit}
          currPage={props.tabFilters.skip}
          totalRecords={props.totalRecords}
          paginationUpdated={paginationUpdated}
        />
      )}
    </div>
  );
};

export default CustomDataTable;

CustomDataTable.defaultProps = {
  header: [],
  totalRecords: 0,
  sortableTable: true,
  disbleAll: false,
  disableSearchText: false,
  disableFilterPagination: false,
  disableTopFilters: false,
  bottomContent: "",
  searchColumnText: "Search all columns:"
};

CustomDataTable.prototype = {
  header: PropTypes.array.isRequired, // table header
  totalRecords: PropTypes.number.isRequired, // total entries count
  setFilters: PropTypes.func.isRequired, // functions to pass filters to parent component
  disableFilterPagination: PropTypes.bool, // disable the top filters and paginations
  sortData: PropTypes.func, // sorting data function
  tabFilters: PropTypes.object, // current filters values
  sortableTable: PropTypes.bool, // to make siorting enable or disable for columns
  disbleAll: PropTypes.bool, // to disable all data fetching for table,
  disableSearchText: PropTypes.bool, // disable the search columns text field
  disableTopFilters: PropTypes.bool,
  bottomContent: PropTypes.string,
  searchColumnText: PropTypes.string
};

/* here table header can contains an array of objects of this type

{
  key: string and the key which will be used for sorting,
  value: string value which will be used in showing the header column,
  customStyle: style object for this column,
  sort: boolean to disable sorting for this column. By default it will be enabled
}

*/
